export function getCardStyle() {
    return {
        base: {
            "color": getComputedStyle(document.body).getPropertyValue("--label-primary"),
            "fontSize": "13px",
            "lineHeight": "16px",
            "border": "1px solid #ced4da", // Change this to the desired border style
            "fontFamily": getComputedStyle(document.body).getPropertyValue("--font-family"),
            "fontSmoothing": "antialiased",
            "::placeholder": {
                color: getComputedStyle(document.body).getPropertyValue("--label-secondary")
            }
        },
        invalid: {
            color: getComputedStyle(document.body).getPropertyValue("--label-critical")
        }
    };
}

export function getStripeConfig() {
    return { locale: "us",
        appearance: {
            labels: "above",
            variables: {
                spacingGridRow: "8px",
                borderRadius: "2px",
                fontFamily: getComputedStyle(document.body).getPropertyValue("--font-family"),
                backgroundColor: getComputedStyle(document.body).getPropertyValue("--control-default"),
                iconColor: "#554d56"
            },
            rules: {
                ".Input": {
                    lineHeight: "16px",
                    fontSize: "13px",
                    padding: "3px 8px",
                    boxShadow: "unset",
                    border: `1px solid ${getComputedStyle(document.body).getPropertyValue("--control-default")}`,
                    backgroundColor: getComputedStyle(document.body).getPropertyValue("--control-default"),
                    color: getComputedStyle(document.body).getPropertyValue("--label-primary")
                },
                ".Input--invalid": {
                    color: getComputedStyle(document.body).getPropertyValue("--label-critical"),
                    border: "unset",
                    boxShadow: "unset"
                },
                ".Input--placeholder": {
                    color: getComputedStyle(document.body).getPropertyValue("--label-secondary"),
                    border: "unset",
                    boxShadow: "unset"
                },
                ".Label": {
                    lineHeight: "13px",
                    fontSize: "11px",
                    fontFamily: getComputedStyle(document.body).getPropertyValue("--font-family"),
                    color: getComputedStyle(document.body).getPropertyValue("--label-secondary")
                },
                ".Input:focus": {
                    border: `1px solid ${getComputedStyle(document.body).getPropertyValue("--label-accent")}`,
                    boxShadow: "unset"
                },
                ".Error": {
                    fontSize: "12px",
                    color: getComputedStyle(document.body).getPropertyValue("--label-critical")
                }
            }
        } };
}
